
































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import CouponDefine from '@/model/coupon/couponDefine'
import Coupon from '@/model/coupon/coupon'
import moment from 'moment'

@Component
export default class CouponComponent extends Vue {
  @Prop() private conpon?: Coupon
  private deadline: string = ''

  mounted() {
    this.deadline = this.dateFormat(new Date(this.conpon!.endTime!), new Date())

    this.$forceUpdate()
  }

  get dayFormat() {
    if (this.conpon && this.conpon.couponBusinessStatus === 'UNARRIVED') {
      let time = moment(this.conpon.gmtModified)
        .add(7 * 24 * 60 * 60, 'seconds')
        .diff(moment(), 'seconds')
      console.log(time)

      const days = Math.ceil(time / (24 * 3600))
      if (days >= 0) {
        return days + '天到账'
      } else {
        return '0天到账'
      }
    }
    return ''
  }

  dateFormat(endTime: Date, startTime: Date) {
    let time: number = endTime.getTime() - startTime.getTime()
    const days: number = Math.floor(time / (24 * 3600 * 1000))

    let leavHours: number = time % (24 * 3600 * 1000)
    const hours: number = Math.floor(leavHours / (3600 * 1000))

    let leavMin: number = leavHours % (3600 * 1000)
    const mins: number = Math.floor(leavMin / (60 * 1000))

    let leavSec: number = leavMin % (60 * 1000)
    const seconds: number = Math.floor(leavSec / 1000)

    return days + '天' + hours + '小时' + mins + '分钟' + seconds + '秒'
  }

  private momentDataFormat(data: string) {
    return moment(data).toDate()
  }
}
